import { useSelector } from 'react-redux';

import { selectJsonQuery } from '../../../../../shared/common/selectors/filters';
import { useStarRatingEnabled } from '../../../../../shared/common/utils/experiments/hotels/starRating';
import { dealTypeFromJsonQuery, FDealType, FOfferType, offerTypeFromJsonQuery } from '../../../../JsonQuery';
import { TFilter } from '../../types/filters';

function getDealOfferTypesChecker(currentDealType: FDealType, currentOfferType: FOfferType) {
  return (dealType: FDealType, offerType: FOfferType) => {
    return (dealType & currentDealType) !== 0 && (offerType & currentOfferType) !== 0;
  };
}

export function useAvailableFilters(): TFilter[] {
  const jsonQuery = useSelector(selectJsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const checkDealOffer = getDealOfferTypesChecker(dealType, offerType);
  const isStarRatingEnabled = useStarRatingEnabled();

  // Посутка кроме отелей
  if (checkDealOffer(FDealType.RentDaily, FOfferType.Any & ~FOfferType.Hotel)) {
    return ['dealType', 'offerType', 'price', 'beds', 'roomType', 'dates', 'advancedFilters', 'geo'];
  }

  // Отели
  if (checkDealOffer(FDealType.RentDaily, FOfferType.Hotel)) {
    return ['dealType', 'dates', 'beds', 'offerType', 'price', isStarRatingEnabled && 'starRating', 'geo'].filter(
      Boolean,
    ) as TFilter[];
  }

  // Продажа участков (не используется тк происходит редирект в другой мкс)
  if (checkDealOffer(FDealType.Sale, FOfferType.Land)) {
    return ['dealType', 'offerType', 'posessor', 'price', 'advancedFilters', 'geo'];
  }

  // Продажа загородных домов (не используется тк происходит редирект в другой мкс)
  if (checkDealOffer(FDealType.Sale, FOfferType.Suburban & ~FOfferType.Land)) {
    return ['dealType', 'offerType', 'posessor', 'price', 'advancedFilters', 'geo'];
  }

  // Долгосрочная аренда загородных домов (не используется тк происходит редирект в другой мкс)
  if (checkDealOffer(FDealType.RentLongterm, FOfferType.Suburban)) {
    return ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'];
  }

  // Продажа или долгосрочная аренда комерческой, кроме коммерческих участков
  if (checkDealOffer(FDealType.Sale | FDealType.RentLongterm, FOfferType.Commercial & ~FOfferType.CommercialLand)) {
    return ['dealType', 'offerType', 'price', 'area', 'advancedFilters', 'geo'];
  }

  // Любая сделка с коммерческими участками
  if (checkDealOffer(FDealType.Any, FOfferType.CommercialLand)) {
    return ['dealType', 'offerType', 'price', 'landArea', 'advancedFilters', 'geo'];
  }

  // Любая сделка с квартирой
  if (checkDealOffer(FDealType.Any, FOfferType.Flat)) {
    return ['dealType', 'offerType', 'roomType', 'price', 'advancedFilters', 'geo'];
  }

  // Любая сделка с городской недвижимостью кроме квартир
  if (checkDealOffer(FDealType.Any, FOfferType.Urban & ~FOfferType.Flat)) {
    return ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'];
  }

  // Любая сделка с другим типом недвижки
  if (checkDealOffer(FDealType.Any, FOfferType.Other)) {
    return ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'];
  }

  return [];
}
